import { Component, ChangeDetectionStrategy, Optional, OnInit } from '@angular/core';

import { PublicOrganization } from '@lib/auth/public';
import { TranslationService, setGlobalTranslationService } from '@lib/translation';

import { environment } from '../environments/environment';

@Component({
  selector: 'fr-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  public favicoArray: string[] = ['#appIconApple', '#appIcon32', '#appIcon16', '#appIcon'];
  readonly isProduction = environment.production;

  constructor(
    @Optional() public readonly organization: PublicOrganization,
    private readonly _translationService: TranslationService,
  ) {
    setGlobalTranslationService(this._translationService);
  }

  public ngOnInit(): void {
    if (this.organization?.favicoUrl) {
      this.favicoArray.forEach((value) => {
        const favIcon: HTMLLinkElement = document.querySelector(value);
        favIcon.href = this.organization.favicoUrl;
      });
    }
  }
}
